<p-toast></p-toast>

<div class="user-management-page">
  <div class="page-header">
    <app-back-button
      [title]="'User Management'"
      [ngStyle]="{ 'font-size': isSmallScreen ? '14px' : 'inherit' }"
      parentRoute="/admin"></app-back-button>
    <div class="page-header">
      <p class="page-subtitle">{{ "Configure user roles and manage permissions" | translate }}</p>
    </div>
  </div>

  @if (loading) {
  <div class="h-full w-full">
    <app-loading [loading]="loading"></app-loading>
  </div>
  } @else {
  <div class="page-content">
    <div class="tabs-section">
      <p-tabs
        [(value)]="activeTab"
        (onChange)="onTabChange($event)">
        <p-tablist>
          <p-tab value="0">{{ "Users" | translate }}</p-tab>
          <p-tab value="1">{{ "Roles" | translate }}</p-tab>
          <p-tab value="2">{{ "Lock Permissions" | translate }}</p-tab>
        </p-tablist>

        <p-tabpanels>
          <p-tabpanel value="0">
            <app-user-list
              [users]="users"
              [rolesData]="rolesData"
              [totalRecords]="totalRecords"
              [loading]="loading"
              [isSmallScreen]="isSmallScreen"
              [(pageSize)]="pageSize"
              (pageSizeChange)="onPageSizeChange($event)"
              [(filters)]="filters"
              [userSelectorConfig]="userSelectorConfig"
              [orgSelectorConfig]="orgSelectorConfig"
              [roleSelectorConfig]="roleSelectorConfig"
              (onEditUser)="editUser($event)"
              (onApplyFilters)="applyFilters()"
              (onClearFilters)="clearFilters()"
              (onAddIndividual)="addIndividualUser()"
              (onAddLegal)="addLegalEntityUser()"
              (onImportIndividual)="importIndividualUsers()"
              (onImportLegal)="importLegalEntityUsers()"></app-user-list>
          </p-tabpanel>

          <p-tabpanel
            value="1"
            *ngIf="activeTab == '1'">
            <app-user-roles-list
              [rolesData]="rolesData"
              [roleUserCounts]="roleUserCounts"
              [selectedRole]="selectedRole"
              (onSelectRole)="selectRole($event)"
              (onShowUserInRole)="showUserInRole($event.role, $event.event)"></app-user-roles-list>
          </p-tabpanel>
          <p-tabpanel
            value="2"
            *ngIf="activeTab == '2'">
            <app-lock-permissions></app-lock-permissions>
          </p-tabpanel>
        </p-tabpanels>
      </p-tabs>
    </div>
  </div>
  }
</div>

<app-user-management-modals
  #modals
  [rolesData]="rolesData"
  (onUserSaved)="onUserSaved()"></app-user-management-modals>
